module.exports = __webpack_public_path__ + "img/box9-img-2.0c0e2730.png";